import { colors } from '../Token/token';

export const TEXT_TAGS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  div: 'div',
  span: 'span',
  p: 'p'
};

export const VARIANTS = [
  'primary-text',
  'secondary-text',
  'body-text',
  'secondary-body-text',
  'primary-dark',
  'body1',
  'body2',
  'button',
  'overline',
  'hero',
  'display',
  'headline',
  'title-1',
  'title-2',
  'title-3',
  'ui-huge',
  'ui-large',
  'ui-baseline',
  'ui-small',
  'ui-tiny',
  'caption-tiny',
  'caption-micro'
];

export const INKS: { [key: string]: string } = {
  white: colors.uiLightPrimary,
  highlight: colors.uiDarkPrimary,
  label: colors.uiBlueDarker,
  alert: colors.uiYellow,
  warning: colors.uiRedPrimary,
  positive: colors.uiBlueCerulean,
  price: colors.uiGreenTeal,
  primary: colors.uiOrangePrimary,
  grayscale: '#babcbe', //TODO: Change to constant if navigation image is changed to icon
  secondary: colors.uiBlueDarker,
  muted: colors.uiGrayDarker,
  'primary-interactive': colors.uiDarkPrimary,
  'destructive-interactive': colors.uiRedDarker,
  'gray-warm': colors.uiGrayWarmDark,
  midnight: colors.uiMidnight,
  'gray-raven': colors.uiGrayRaven
};
